"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var TravelAgent_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelAgent = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
let TravelAgent = TravelAgent_1 = class TravelAgent {
    category = legacy_enums_1.TravelAgentCategory.DITA;
    currency = legacy_enums_1.Currency.Dollar;
    discountCoefficient;
    commissionPercentage = 0;
    approvedAt;
    createdAt = new Date();
    declinedAt;
    declinationReason;
    agentId;
    hostAgencyId;
    partnerBookingAvailable = false;
    ownerId;
    realizedOrders = 0;
    realizedOrdersCalculatedAt = new Date();
    tags = [];
    bizDevLeads; // used to save different data for marketing biz dev team sales
    isHostAgencyAdmin = false;
    get status() {
        return (0, statusGetter_1.statusGetter)(this, TravelAgent_1, legacy_enums_1.TravelAgentStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.TravelAgentStatus.Declined:
                return {
                    declinedAt: defined,
                };
            case legacy_enums_1.TravelAgentStatus.Approved:
                return {
                    declinedAt: undefined,
                    approvedAt: defined,
                };
            case legacy_enums_1.TravelAgentStatus.Pending:
            default:
                return {
                    declinedAt: undefined,
                    approvedAt: undefined,
                };
        }
    }
};
exports.TravelAgent = TravelAgent;
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(() => legacy_enums_1.TravelAgentCategory),
    (0, class_validator_1.IsEnum)(legacy_enums_1.TravelAgentCategory),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TravelAgent.prototype, "category", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(() => legacy_enums_1.Currency),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], TravelAgent.prototype, "currency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], TravelAgent.prototype, "discountCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], TravelAgent.prototype, "commissionPercentage", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], TravelAgent.prototype, "approvedAt", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], TravelAgent.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], TravelAgent.prototype, "declinedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : value)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TravelAgent.prototype, "declinationReason", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TravelAgent.prototype, "agentId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TravelAgent.prototype, "hostAgencyId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], TravelAgent.prototype, "partnerBookingAvailable", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : value)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], TravelAgent.prototype, "ownerId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], TravelAgent.prototype, "realizedOrders", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], TravelAgent.prototype, "realizedOrdersCalculatedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], TravelAgent.prototype, "tags", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], TravelAgent.prototype, "bizDevLeads", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.ValidateIf)((agent) => !agent.hostAgencyId),
    (0, class_validator_1.IsIn)([false], { message: "To set as Host Agency Admin, first select a Host Agency" }),
    __metadata("design:type", Boolean)
], TravelAgent.prototype, "isHostAgencyAdmin", void 0);
exports.TravelAgent = TravelAgent = TravelAgent_1 = __decorate([
    (0, class_transformer_1.Exclude)(),
    (0, type_graphql_1.ObjectType)("TravelAgent")
], TravelAgent);
//# sourceMappingURL=TravelAgent.js.map